export class TicketTypeModel {
    id: number;
    value: string;
    rowStatus: number;
    operatingCountry: number;
    createdDate: Date;
    updatedDate: Date;
    createdBy: number;
    updatedBy: number;
    operatingCountryName: string;
}

export class TicketSubtypeModel {
    id: number;
    value: string;
    rowStatus: number;
    operatingCountry: number;
    ticketTypeId: number;
    createdDate: Date;
    updatedDate: Date;
    createdBy: number;
    updatedBy: number;
    operatingCountryId:number;
    operatingCountryName: string;
    ticketType:string;
    ticketSubType:string;
    ticketSubTypeId:number;

}




// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/ticket-types-model.ts